export const MINISITE_FILTER_KEY = 'minisiteId';

export const SORT_OPTION = {
  SAVED: {
    key: '-modified',
    label: 'Date saved',
  },
  ALPHABETICALLY: {
    key: 'title',
    label: 'Alphabetically',
  },
};
export const DEFAULT_SORT = SORT_OPTION.SAVED;
export const SORT_OPTIONS = Object.values(SORT_OPTION);

export const ASSET_TYPE = {
  PPT: {
    id: '6152ef42bc9fe27915ca4ef0',
    title: 'Activity card (PPT)',
  },
  VIDEO: {
    id: '6152ef42bc9fe27915ca4ef1',
    title: 'Video',
  },
  PDF: {
    id: '6152ef42bc9fe27915ca4ef2',
    title: 'PDF',
  },
};
